import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Checkbox, Select,
  Input,
  Popover,
} from 'antd';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const CurrencyConversionV2 = ({
  selectedCurrencyName, setIsAutomaticConversionRate, setCurrencyConversionRate, isAutomaticConversionRate, getCurrenciesLoading, currencyConversionRate, callback,user
}) => {
const  orgCurrencyInfo = user?.tenant_info?.org_default_currency_info;
  const content = (
    <div style={{ marginLeft: "5px", textAlign: "left", width: "200px" }}>
      <Input
        type="number"
        size="small"
        style={{ width: "110px" }}
        value={
                isAutomaticConversionRate
                ? selectedCurrencyName?.automatic_conversion_rate || 0.1
                : currencyConversionRate
              }
        disabled={
          isAutomaticConversionRate || getCurrenciesLoading || selectedCurrencyName?.is_default
        }
        onChange={(e) => {
          const conversionRate = e.target.value > 0 ? e.target.value : 0.1;
          setCurrencyConversionRate(conversionRate);

          if (callback) {
            callback(conversionRate);
          }
        }}
      />
      <Checkbox
        checked={isAutomaticConversionRate}
        onChange={(e) => {
          const selectedCurrency = selectedCurrencyName;
          const conversionRate = isAutomaticConversionRate
            ? selectedCurrency?.automatic_conversion_rate
            : currencyConversionRate;
          setCurrencyConversionRate(conversionRate);
          setIsAutomaticConversionRate(e?.target?.checked); 
          if (callback) {
            callback(conversionRate);
          }
        }}
        style={{ fontSize: "12px" }}
        disabled={getCurrenciesLoading || selectedCurrencyName?.is_default}
      >
        Automatic Conversion Rate
      </Checkbox>
    </div>
  );

  return selectedCurrencyName ? (
    selectedCurrencyName?.currency_code !== orgCurrencyInfo?.currency_code ? (
      <Fragment>
        <div style={{fontSize:'11px', color: 'grey', whiteSpace: 'nowrap', fontWeight: '400'}}>
          <span>
          {isAutomaticConversionRate ? selectedCurrencyName?.automatic_conversion_rate
              : currencyConversionRate} {orgCurrencyInfo?.currency_code} {orgCurrencyInfo?.currency_symbol} =  1 {selectedCurrencyName?.currency_code} {selectedCurrencyName?.currency_symbol}
          </span>
        </div>
        <Popover content={content} title="Conversion Settings" trigger="click">
          <div className="currency__wrapper">      
            {selectedCurrencyName?.currency_code} {selectedCurrencyName?.currency_symbol}
            &nbsp;
            <FontAwesomeIcon icon={faEdit} />
          </div>
        </Popover>
      </Fragment>
    ) : (
        <div style={{ marginLeft: "5px", textAlign: "right" }}>
          <div className="currency__wrapper__disabled">
            {selectedCurrencyName?.currency_code} {selectedCurrencyName?.currency_symbol}
          </div>
        </div>
    )
  ) : (
      <div style={{ marginLeft: "5px", textAlign: "right" }}>
        <div className="currency__wrapper__disabled">
          {orgCurrencyInfo?.currency_code} {orgCurrencyInfo?.currency_symbol}
        </div>
      </div>
      )
};

const mapStateToProps = ({
  UserReducers, CurrenciesReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  CurrenciesResults: CurrenciesReducers.CurrenciesResults,
  getCurrenciesLoading: CurrenciesReducers.getCurrenciesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrencies: (orgId) => dispatch(CurrenciesActions.getCurrencies(orgId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CurrencyConversionV2));
